import React, { useEffect, useState, useRef } from "react";
import CardImage from "../../atoms/card-image";
import VisualStoryModal from "../visual-story-modal";
import "./visual-story-mobile.m.css";

// VisualStory component definition
const VisualStoryMobile = () => {
  const [visualStoryCategory, setVisualStoryCategory] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const visualStoryRef = useRef(null);
  const [scrollStarted, setScrollStarted] = useState(false);
  const [scrollEnded, setScrollEnded] = useState(false);
  const [currentStoryIndex, setCurrentStoryIndex] = useState(0);


useEffect(() => {
  async function fetchAPI() {
    try {
      const response = await fetch(`/api/v1/collections/visual-story`);
      const json = await response.json();

      //filter stories without main image
      const filteredItems = json.items.filter(item => item.story['hero-image-s3-key']);

      setVisualStoryCategory(filteredItems);
    } catch (error) {
      console.error("Error fetching visual stories:", error);
    }
  }
  fetchAPI();
}, []);

useEffect(() => {
  const handleScroll = () => {
    const visualStoryElement = visualStoryRef.current;
    if (!visualStoryElement) return;
    setScrollStarted(visualStoryElement.scrollLeft > 5);
    setScrollEnded(visualStoryElement.scrollLeft + visualStoryElement.clientWidth >= visualStoryElement.scrollWidth - 5);
  };

  const visualStoryElement = visualStoryRef.current;
  if (visualStoryElement) {
    visualStoryElement.addEventListener("scroll", handleScroll);
    handleScroll();
  }
  return () => {
    if (visualStoryElement) visualStoryElement.removeEventListener("scroll", handleScroll);
  };
}, [visualStoryCategory]); // re-run when stories load

  const visualStoryTopics = [...visualStoryCategory || []];

  if (visualStoryTopics.length < 1) {
    return null;
  }

  const handleLinkClick = (index) => {
    const story = visualStoryTopics[index].story;
    setCurrentStoryIndex(index);
    setModalContent(<iframe src={story.url} width="100%" height="100%" />);
    setIsModalOpen(true);
  };
  const handleNextStory = () => {
    const nextIndex = (currentStoryIndex + 1) % visualStoryTopics.length;
    handleLinkClick(nextIndex);
  };

  const handlePreviousStory = () => {
    const prevIndex = (currentStoryIndex - 1 + visualStoryTopics.length) % visualStoryTopics.length;
    handleLinkClick(prevIndex);
  };

  return (
    <React.Fragment>
      <div styleName="visual-story-wrapper" style={{ position: "relative" }}>
        <div
          ref={visualStoryRef}
          styleName={`visual-story`}
        >
          {visualStoryTopics
            .filter(item => item.story['hero-image-s3-key'])
            .slice(0, 12)
            .map((item, index) => (
              <div
                key={index}
                onClick={() => handleLinkClick(index)}
                style={{ display: 'inline-block', cursor: 'pointer' }}>
                <div styleName="visual-story-item">
                  <CardImage
                    story={item.story}
                    defaultWidth={183}
                    aspectRatio={[4, 3]}
                    imageType="image9x16"
                  />
                  <div styleName="play-button-bg">
                    <i className="ri-play-fill" styleName="play-icon"></i>
                  </div>
                </div>
                <div><h2 styleName="visual-story-title">{item.story.headline}</h2></div>
              </div>
          ))}
        </div>
                {/* Fading gradients */}
          {!scrollEnded && (<div styleName="scroll-gradient scroll-gradient-right" />)}
          {scrollStarted && (<div styleName="scroll-gradient scroll-gradient-left" />)}
      </div>
      <VisualStoryModal
        show={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        closePopup={() => setIsModalOpen(false)}
        onNext={handleNextStory}
        onPrevious={handlePreviousStory}
        currentStoryIndex={currentStoryIndex}
      >
        {modalContent}
      </VisualStoryModal>
    </React.Fragment>
  );

};

export default VisualStoryMobile;
